import API from '../../../API/api';
import {getCsrfTokenQueryParam} from '../../../utilities/csrf_token_provider';

export const removeWheelAlignment = async () => {
    try {
        let response;
        response = await API.DELETE({
            apiPath: `/api/v2/checkout/services/wheelalignment/?${getCsrfTokenQueryParam()}`,
            data: JSON.stringify({ }),
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
        });
        
        return Promise.resolve(response);
    } catch (error) {
        console.log(error);
        return Promise.reject(error);
    }
};
